import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { BASE_URL, USER_URL } from '../../constant/api';
import { RiStarSFill } from 'react-icons/ri';
import FeedBackSectionForOne from '../../components/AdminDashboard/FeedbackSection/FeedBackSectionForOne';

const AdminAppFeedbackCustomer = () => {
    const [Feedbacks, setFeedbacks] = useState([]);
    const [OverallRating, setOverallRating] = useState(0);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedRating, setSelectedRating] = useState(null); // Null means all ratings

    // Reusable function to fetch data
    const fetchData = async (url, setter) => {
        try {
            const response = await USER_URL.get(url);
            setter(response.data.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchOverallRatingData = async (url, setter) => {
        try {
            const response = await USER_URL.get(url);
            setter(response.data['Overall customer App Rating'] || 0);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData(`/accounts/admin/feedbacks/?user_type=customer`, setFeedbacks);
        fetchOverallRatingData(`/accounts/admin/overall-app-rating/?user_type=customer`, setOverallRating);
    }, []);

    // Function to filter feedback based on selected date and rating
    const filterFeedback = (feedbacks) => {
        return feedbacks.filter((feedback) => {
            // Use created_at instead of date
            const feedbackDate = new Date(feedback.created_at).toISOString().split('T')[0];
            const matchesDate = selectedDate ? feedbackDate === selectedDate : true;

            // Adjust rating comparison using Math.floor to compare whole numbers
            const matchesRating = selectedRating
                ? Math.floor(feedback.rating) === selectedRating
                : true;

            return matchesDate && matchesRating;
        });
    };
    return (
        <div className="flex flex-col p-4">
            <h1 className="text-2xl font-medium text-green-600 ">Customer App Feedback</h1>
            {/* Filters */}
            <div className="flex gap-4 mb-4">
                <button
                    className={`px-3 py-1 rounded ${selectedRating === null ? 'bg-white text-green-500 border border-green-500' : 'border border-gray-300'}`}
                    onClick={() => setSelectedRating(null)}
                >
                    All
                </button>
                <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    className="p-2 border rounded"
                />

                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        className={`px-3 flex items-center py-1 rounded ${selectedRating === star ? 'bg-white text-green-500 border border-green-500' : 'border border-gray-300'}`}
                        onClick={() => setSelectedRating(star === selectedRating ? null : star)}
                    >
                        <RiStarSFill className='mr-2 text-yellow-500 text-2xl' /> {star} Rating
                    </button>
                ))}
            </div>

            {/* Seller Feedback Section */}
            <div className="flex flex-col md:flex-row gap-4">
                <FeedBackSectionForOne
                    title="Customer Feedbacks"
                    rating={OverallRating}
                    reviews={filterFeedback(Feedbacks)}
                    reviewCount={filterFeedback(Feedbacks).length}
                />
            </div>
        </div>
    );
}

export default AdminAppFeedbackCustomer